import React from 'react';
import glamorous from 'glamorous';
import ToolCard from './index';
import {buildStackupSlug} from '../../utils';
import AddToolButton from '../buttons/add-tool';

const AddToolCard = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%'
});

const EMPTY_TOOL = () => ({slug: ''});

const removeIndex = (arr, index) => arr.filter((val, i) => i !== index);

const onAddTool = (navigate, tools) => () =>
  navigate(`/stackups/${buildStackupSlug([...tools, EMPTY_TOOL()])}`);

const RenderToolCard = ({
  tools,
  index,
  minimal,
  navigate,
  focus,
  onAddClick,
  contactEnabledTools,
  stackupPath = null,
  tooltip,
  userIsAdmin,
  emptySpaceComponent,
  triggerEvent
}) => {
  const nonEmptyTools = tools.filter(t => !t.empty);
  const loadingTools = tools.filter(t => t.loading);
  const vendorInStackup = tools.map(tool => tool.contactEnabled).some(item => item === true);
  if (index < tools.length) {
    if (tools[index].loading) {
      return (
        <ToolCard
          tool={null}
          onRemove={null}
          minimal={minimal}
          userIsAdmin={userIsAdmin}
          triggerEvent={false}
        />
      );
    } else if (tools[index].empty) {
      return (
        <ToolCard
          userIsAdmin={userIsAdmin}
          tool={null}
          onChange={({_result}) =>
            navigate(`/stackups/${buildStackupSlug([...nonEmptyTools, _result])}`)
          }
          minimal={minimal}
          focus={focus}
          otherToolSlugs={tools.filter(t => t.slug).map(t => t.slug)}
          triggerEvent={false}
        />
      );
    } else {
      return (
        <ToolCard
          tool={tools[index]}
          onRemove={
            nonEmptyTools.length > 1 && loadingTools.length === 0
              ? () => navigate(`/stackups/${buildStackupSlug(removeIndex(tools, index))}`)
              : null
          }
          minimal={minimal}
          vendorInStackup={vendorInStackup}
          contactEnabledTools={contactEnabledTools}
          stackupPath={stackupPath}
          tooltip={tooltip}
          userIsAdmin={userIsAdmin}
          triggerEvent={triggerEvent}
        />
      );
    }
  } else if (
    index === tools.length &&
    nonEmptyTools.length === tools.length &&
    loadingTools.length === 0
  ) {
    return (
      <AddToolCard>
        {emptySpaceComponent ? (
          emptySpaceComponent
        ) : (
          <AddToolButton
            minimal={minimal}
            onClick={onAddClick ? () => onAddClick(tools) : onAddTool(navigate, tools)}
          />
        )}
      </AddToolCard>
    );
  } else {
    return <div style={{width: '100%'}} />;
  }
};

export default RenderToolCard;
